export const fieldIdMap = {
  location: "onboardingLocation",
  item_number: "itemType",
};
